/** localStorage keys for every persisted slice of dashboard state. */
export const STORAGE_KEYS = {
  layout: 'acc-layout',
  sectionOrder: 'acc-sec-order',
  sections: 'acc-sections',
  sectionOwners: 'acc-sec-owners',
  owners: 'acc-owners',
  overrides: 'acc-overrides',
  planned: 'acc-planned',
  codes: 'acc-codes',
  folded: 'acc-folded',
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];

/** Reads persisted JSON, falling back whenever storage is unavailable or the payload is corrupt. */
export const readStored = <T>(key: StorageKey, fallback: T): T => {
  try {
    const raw = localStorage.getItem(key);
    return raw === null ? fallback : (JSON.parse(raw) as T);
  } catch {
    return fallback;
  }
};

/** Persists JSON, swallowing quota and privacy-mode failures so the app keeps running. */
export const writeStored = <T>(key: StorageKey, value: T): void => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // persistence is best-effort
  }
};
